import { Dialog, DialogTitle, DialogContent, Box, Typography, useTheme } from "@mui/material";

interface CuratedBackground {
    small: string;
    original: string;
}

interface CuratedDialogProps {
    open: boolean;
    onClose: () => void;
    curatedBackgrounds: CuratedBackground[];
    selectedBackground?: string | null; //  allow null
    pageId: string;
    setPageBackgroundImage: (pageId: string, src: string | null) => void;

}

export const CuratedBackgroundDialog: React.FC<CuratedDialogProps> = ({
    open,
    onClose,
    curatedBackgrounds,
    selectedBackground,
    pageId,
    setPageBackgroundImage,
}) => {
    const theme = useTheme();


    const handleThumbClick = (index: number) => () => {
        const bgSmall = curatedBackgrounds[index].small;

        //  FIX: blur focused element before closing dialog
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }

        setPageBackgroundImage(pageId, bgSmall);
        onClose();
    };


    // Helper: extract file name from path
    const getName = (path: string) => {
        try {
            const parts = path.split("/");
            let filename = decodeURIComponent(parts[parts.length - 1]);
            filename = filename.replace(/\.(jpg|jpeg|png|webp|gif)$/i, "").trim();
            // Capitalize first letter
            return filename.charAt(0).toUpperCase() + filename.slice(1);
        } catch {
            return path;
        }
    };

    return (
        <>
            {/* THUMBNAIL PICKER DIALOG */}
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth={false}
                disableRestoreFocus
                PaperProps={{ sx: { width: 860, maxWidth: "96vw" } }}
            >
                <DialogTitle>
                    Select Background
                    <Typography
                        variant="caption"
                        sx={{ display: "block", mt: 0.5, color: "text.secondary", fontSize: 14 }}
                    >
                        Hover to zoom – Click to apply
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(5, 140px)",
                            gap: 3,

                            justifyContent: "center",
                            p: 1,
                        }}
                    >
                        {curatedBackgrounds.map((bg, index) => {
                            const isSelected = selectedBackground === bg.small;
                            return (
                                <Box key={bg.small}>
                                    <Box
                                        onClick={handleThumbClick(index)}
                                        sx={{
                                            width: 140,
                                            height: 70,
                                            cursor: "pointer",
                                            border: isSelected
                                                ? `2px solid ${theme.palette.primary.main}`
                                                : "1px solid #ccc",
                                            boxShadow: isSelected
                                                ? "0 0 6px rgba(25,118,210,0.6)"
                                                : "none",

                                            transform: "scale(1)",
                                            transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                            zIndex: 1,
                                            position: "relative",

                                            "&:hover": {
                                                transform: "scale(1.2)", //  grow the thumb itself
                                                zIndex: 10,
                                                boxShadow: "0 6px 18px rgba(0,0,0,0.35)",
                                            },
                                        }}
                                    >
                                        <img
                                            src={bg.small}
                                            alt={getName(bg.small)}
                                            draggable={false}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                display: "block",
                                                userSelect: "none",
                                                pointerEvents: "none",
                                            }}
                                        />
                                    </Box>
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            mt: 0.3,
                                            textAlign: "center",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            width: "100%",
                                        }}
                                    >
                                        {getName(bg.small)}
                                    </Typography>
                                </Box>
                            );
                        })}
                    </Box>
                </DialogContent>
            </Dialog>


        </>
    );
};
